import React, { useEffect } from 'react';

const HomeBooking = () => {
  useEffect(() => {
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal; let ar = arguments;
        if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement('script')).src = A; cal.loaded = true; }
        if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; if (typeof namespace === 'string') { cal.ns[namespace] = cal.ns[namespace] || api; p(cal.ns[namespace], ar); p(cal, ['initNamespace', namespace]); } else p(cal, ar); return; } p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');
    window.Cal('init', '30-min-valtivo', { origin: 'https://app.cal.com' });
    window.Cal.ns['30-min-valtivo']('inline', {
      elementOrSelector: '#valtivo-cal-inline',
      config: { layout: 'month_view', useSlotsViewOnSmallScreen: 'true', theme: 'light' },
      calLink: 'ilyalabs/30-min',
    });
    window.Cal.ns['30-min-valtivo']('ui', { theme: 'light', hideEventTypeDetails: false, layout: 'month_view' });
  }, []);

  return (
    <section id="booking" className="py-16" style={{ background: '#f0fdf4' }}>
      <div className="max-w-5xl mx-auto px-8 lg:px-16">
        <div className="text-center mb-10">
          <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#16a34a' }}>Book a Call</p>
          <h2 className="text-3xl font-bold mb-3" style={{ color: '#052e16' }}>Schedule a 30-minute discovery call.</h2>
          <p className="text-sm max-w-xl mx-auto leading-relaxed" style={{ color: '#166534' }}>
            We'll review how your team currently tracks assets and handles support requests, identify where things break down, and determine whether this is the right fit for your operation.
          </p>
        </div>
        <div className="rounded-xl overflow-hidden border" style={{ borderColor: '#bbf7d0' }}>
          <div style={{ width: '100%', height: '900px', overflow: 'scroll' }} id="valtivo-cal-inline" />
        </div>
      </div>
    </section>
  );
};

export default HomeBooking;